module.exports = __webpack_public_path__ + "static/media/altaproteina_harinadetrigo.e604e345.png";